
namespace Gamification.Gamification {
    export class UtentiParametriGlobaliColumns {
        static columnsKey = 'Gamification.UtentiParametriGlobali';
    }
}